import { useAudioGraphStore } from './useAudioGraphStore';

export const useAudioAnalyzer = () => {
  const getMicAnalyzer = useAudioGraphStore((state) => state.getMicAnalyzerTask);
  const getTabAnalyzer = useAudioGraphStore((state) => state.getTabAnalyzerTask);

  const releaseMicAnalyzer = useAudioGraphStore((state) => state.releaseMicAnalyzerTask);
  const releaseTabAnalyzer = useAudioGraphStore((state) => state.releaseTabAnalyzerTask);

  const micAnalyzerUsers = useAudioGraphStore((state) => state.micAnalyzerUsers);
  const tabAnalyzerUsers = useAudioGraphStore((state) => state.tabAnalyzerUsers);

  return {
    getMicAnalyzer,
    getTabAnalyzer,
    releaseMicAnalyzer,
    releaseTabAnalyzer,
    micAnalyzerUsers,
    tabAnalyzerUsers,
  };
};
